import {Component, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Attachment } from '../models/attachment.model';

@Component({
  selector: 'attachment',
  template: `
    <div class="attachments">
      <ul [ngClass]="{'-deactivated': loading}">
        <li class="fake-label" *ngFor="let attachment of attachments">
          <div>
            <span class="input-icon paperclip-icon"></span>
            <a class="fake-input" href="{{ attachment.url }}" target="_blank">{{ attachment.file | truncate : 20 }} ({{ attachment.size | bytesSize }})</a>
            <div class="remove"><button (click)="removeAttachment(attachment.id)"></button></div>
          </div>
        </li>
        <li class="fake-label" *ngIf="!attchmtBtnHidden">
          <label>
            <span class="input-icon paperclip-icon"></span>
            <span class="fake-input">{{ 'attachments.select_a_file' | translate }}</span>
            <input type="file" (change)="fileChange($event)">
          </label>
        </li>
      </ul>
    </div>
    <div class="error-message">
      <p [hidden]="!error.fileTooBig" class="error">{{ 'attachments.errors.file_too_big' | translate : { size: limit } }}</p>
    </div>
    <button class="new-attachment" (click)="addUploadField()"
      [ngClass]="{'-deactivated': noMoreFiles}">
      {{ 'attachments.new_file' | translate }}</button>
  `,
})

export class AttachmentComponent {
  @Input() attachments: Array<Attachment>;
  @Input() maxFileNumber: number;
  @Input() sizeLimit: number = 52428800;
  @Output() attachmentsChange = new EventEmitter();

  private apiEndpoint: string = '/api/v2/patients/attachments';

  attchmtBtnHidden: boolean;
  loading: boolean;

  error = {
    fileTooBig: false,
  };

  constructor(
    private http: Http,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['attachments']) {
      this.attchmtBtnHidden = false;
      this.loading = false;
    }
  }

  get noMoreFiles(): boolean {
    if (!this.attachments.length || !this.attchmtBtnHidden) {
      return true;
    }
    return this.maxFileNumber && this.maxFileNumber >= this.attachments.length;
  }

  addUploadField() {
    if (!this.noMoreFiles) {
      this.attchmtBtnHidden = false;
    }
  }

  removeAttachment(attchmentId) {
    _.remove(this.attachments, (att) => {
      return att.id === attchmentId;
    });
    if (!this.attachments.length) {
      this.attchmtBtnHidden = false;
    }
    this.attachmentsChange.emit(this.attachments);
  }

  fileChange(event) {
    this.error.fileTooBig = false;

    let fileList: FileList = event.target.files;
    if (fileList.length === 0) { return; }

    let file: File = fileList[0];
    if (file.size > this.sizeLimit) {
      this.error.fileTooBig = true;
      return;
    }

    this.loading = true;
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);

    let headers = new Headers();
    headers.append('Accept', 'application/json');

    const options = new RequestOptions({
      headers: headers,
      method: RequestMethod.Post
    });

    this.http.post(this.apiEndpoint, formData, options)
      .map(res => res.json())
      .catch(error => Observable.throw(error))
      .subscribe(
        data => this.successResponse(data),
      )
  }

  successResponse(data) {
    this.loading = false;
    this.attchmtBtnHidden = true;
    this.attachments.push(data);
    this.attachmentsChange.emit(this.attachments);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/attachment/attachment.component.ts